import { DckActionTypes } from "dck-redux"
import moment from "moment"
import { all, takeEvery } from "redux-saga/effects"
import { ChargeCalculationType, ChargeTimeType, HTTP_VERB } from "../../../lib/utils"
import * as ItemTypes from "../../items/types"
import apiServerConstants from "../apiServerConstants"
import { makeSagaQuery } from "../utils"

function *loadChargesSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/loancharge?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.Charges,
    true,
    response => {

      let charges = response.body
      if (!(charges instanceof Array)) return

      charges = charges.map(item => {

        const { createdOn, dueDate, chargeTimeType, chargeCalculationType } = item

        item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
        item.dueDateFormatted = dueDate ? moment(dueDate).format('ll') : ''
        item.chargeTimeTypeText = ChargeTimeType[chargeTimeType]
        item.chargeCalculationTypeText = ChargeCalculationType[chargeCalculationType]

        return item
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Charges,
        data: charges
      }
    }
  )
}

function* chargesSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Charges,
      loadChargesSaga
    ),
  ])
}

export default chargesSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/charges.js